import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import svgGenerator from "./icons/svgGenerator"

const StyledSkill = styled.div`
  display: flex;
  flex-direction: column;
  .icon {
    width: 3rem;
    height: 3rem;
    &:hover {
      transform: translate3d(0px, -0.075rem, 0px);
    }
  }
  .icon i,
  .icon svg {
    font-size: 2.25rem;
  }
  .icon + .icon-text {
    padding-left: 1rem;
    width: calc(100% - 3rem - 1);
  }
  .icon-xl {
    width: 5rem;
    height: 5rem;
  }
  .icon-xl i,
  .icon-xl svg {
    font-size: 4.25rem;
  }
  .icon-xl + .icon-text {
    width: calc(100% - 0rem - 1);
  }
  .icon-lg {
    width: 4rem;
    height: 4rem;
  }
  .icon-lg i,
  .icon-lg svg {
    font-size: 3.25rem;
  }
  .icon-lg + .icon-text {
    width: calc(100% - 0rem - 1);
  }
  .icon-sm {
    width: 2rem;
    height: 2rem;
  }
  .icon-sm i,
  .icon-sm svg {
    font-size: 1.25rem;
  }
  .icon-sm + .icon-text {
    width: calc(100% - 0rem - 1);
  }
  .icon-xs {
    width: 1.25rem;
    height: 1.25rem;
  }
  .icon-xs i,
  .icon-xs svg {
    font-size: 0.5rem !important;
  }
  .icon-xs + .icon-text {
    width: calc(100% - 0rem - 1);
  }
  .icon-shape {
    padding: 12px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.borderRadius};
    margin: 0 auto;
  }
  .icon-shape i,
  .icon-shape svg {
    font-size: 1.25rem;
  }
  .icon-shape.icon-lg i,
  .icon-shape.icon-lg svg {
    font-size: 1.625rem;
  }
  .icon-shape.icon-sm i,
  .icon-shape.icon-sm svg {
    font-size: 0.875rem;
  }
  .icon-shape svg {
    width: 36px;
    height: 36px;
  }
  .icon-shape-primary {
    color: #2643e9;
    background-color: rgba(138, 152, 235, 0.5);
  }
  .icon-shape-secondary {
    color: #d3d9e5;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .icon-shape-success {
    color: #1aae6f;
    background-color: rgba(84, 218, 161, 0.5);
  }
  .icon-shape-info {
    color: #03acca;
    background-color: rgba(65, 215, 242, 0.5);
  }
  .icon-shape-warning {
    color: #ff3709;
    background-color: rgba(252, 140, 114, 0.5);
  }
  .icon-shape-danger {
    color: #f80031;
    background-color: rgba(247, 103, 131, 0.5);
  }
  .icon-shape-light {
    color: #879cb0;
    background-color: rgba(201, 207, 212, 0.5);
  }
  .icon-shape-dark {
    color: #090c0e;
    background-color: rgba(56, 63, 69, 0.5);
  }
  .icon-shape-default {
    color: #091428;
    background-color: rgba(35, 65, 116, 0.5);
  }
  .icon-shape-white {
    color: #e8e3e3;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .icon-shape-neutral {
    color: #e8e3e3;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .icon-shape-darker {
    color: black;
    background-color: rgba(26, 26, 26, 0.5);
  }
  .shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: ${({ theme }) => theme.skillIconColor};
  }
  .skill-name {
    font-size: 0.75rem;
    text-align: center;
  }
`
// box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.16);
const Skill = ({ skillName, fontAwesomeClassname, starred, isCustomSvg }) => (
  <StyledSkill>
    {starred ? (
      <div
        style={{
          position: "absolute",
          zIndex: 99,
        }}
      >
        <div style={{ position: "relative", bottom: "10px", left: "2px" }}>
          <div style={{ fontSize: "24px", opacity: 100 }}>⭐️</div>
        </div>
      </div>
    ) : (
      <></>
    )}
    <div className="icon icon-xl icon-shape shadow-sm rounded-circle m-1">
      {svgGenerator(fontAwesomeClassname, isCustomSvg)}
    </div>
    <div className="skill-name">{skillName}</div>
  </StyledSkill>
)

Skill.propTypes = {
  skillName: PropTypes.string,
  fontAwesomeClassname: PropTypes.string,
  starred: PropTypes.bool,
  isCustomSvg: PropTypes.bool,
}

export default Skill
